module.exports = __webpack_public_path__ + "static/media/logo_loop_1.c25c4aa4.gif";